import gql from 'graphql-tag';

export default gql`
  mutation sendMagicLink($email: EmailAddress!) {
    sendMagicLink(email: $email)
  }
`;
